import src from "IMAGE";
export default { src, width: 140, height: 35, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AENBEz93YTZZlpWTVqGhoWWOjo5PkJCQVpWVlVxra2stACxnTmtnhnOFn5+ZVbq6unqenp5cp6enaqurq2dOTk4quLMeOH4u6IIAAAAASUVORK5CYII="};
